/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const MainContainer = styled.div`
    width: 100%;
    height: 100vh;
    background-color: ${({ theme }) => theme.color.white.main};
`;
